export default {
  methods: {
    validatePassword (password_) {
      var re1 = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,100}$/;

      return re1.test(password_);
    },
    validateTfno (tfno_) {
      var re1 = /^\d{9}$/;
      var re2 = /^\d{3}-\d{3}-\d{3}$/;
      var re3 = /^\d{3}\s\d{6}$/;
      var re4 = /^\d{3}\s\d{2}\s\d{2}\s\d{2}$/;
      return (
        re1.test(tfno_) || re2.test(tfno_) || re3.test(tfno_) || re4.test(tfno_)
      );
    },
    validateURL (str) {
      var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
      return !!pattern.test(str);
    },
    validateEmail (email_) {
      // eslint-disable-next-line no-control-regex
      var re = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(email_);
    },
    myTrim (x) {
      return x.replace(/^\s+|\s+$/gm, '');
    },
    comprobarContraseñas (password, repassword) {
      let Contraseña = this.myTrim(password);
      let RepetirContraseña = this.myTrim(repassword);
      let validate = false;

      if (Contraseña !== '' && RepetirContraseña !== '') {
        if (this.validatePassword(Contraseña) && this.validatePassword(RepetirContraseña)) {
          if (Contraseña === RepetirContraseña) {
            validate = true;
          }
        }
      }

      return validate;
    },
    checkIfEmpty (array) {
      let empty = false;
      array.map((x) => {
        let localVariable = this.myTrim(x);
        if (localVariable === null || localVariable === '' || localVariable === undefined) {
          empty = true;
        }
      });

      return empty;
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    validateFechaIni (dateInicio, dateFin) {
      if (dateFin !== null && dateFin !== '') {
        return dateInicio <= dateFin;
      }
      return true;
    },
    validateFechaFin (dateInicio, dateFin) {
      if (dateInicio !== null && dateInicio !== '') {
        return dateFin >= dateInicio;
      }
      return true;
    },

    validateFechaIniNoEqual (dateInicio, dateFin) {
      if (dateFin !== null && dateFin !== '') {
        return dateInicio < dateFin;
      }
      return true;
    },
    validateFechaFinNoEqual (dateInicio, dateFin) {
      if (dateInicio !== null && dateInicio !== '') {
        return dateFin > dateInicio;
      }
      return true;
    },
    validateNumberWith2Decimals (val) {
      var re1 = /^(-?\d{1,}(,\d{1,3})*|(\d+))(\.\d{0,2})?$/;
      return re1.test(val);
    }
  }
};
